import React from 'react';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import Benefits, { IBenefit } from '~/src/features/domofon/components/Benefits';
import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

import * as ST from './styled';

const coverImg = '/static/images/domofon-new/benefits_cover.jpg';
const coverImgWebp = '/static/images/domofon-new/benefits_cover.webp';

interface IProps {
    benefitsItems: IBenefit[],
    connectBtnHandler: () => void,
}

export enum EMediaWidth {
    laptop = '(max-width: 1279px)',
    minTablet = '(min-width: 1025px)',
}

const BannerBlock: React.FC<IProps> = ({ benefitsItems, connectBtnHandler }): JSX.Element => {
    const isMinTablet = useMatchMedia(EMediaWidth.minTablet);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);
    const backgroundImg = useProgressiveImage(coverImgWebp, { hasTimeout: true, timeoutDelay: 1 }, coverImg);

    return (
        <ST.Wrapper backgroundImg={backgroundImg ||  ''} data-test='benefits-block'>
            <WideContainer>
                <ST.HeadTitle data-test='benefits-block-title'>Вместе с домофоном вы получите:</ST.HeadTitle>
                <Benefits
                    showCarousel={isLaptop}
                    items={benefitsItems}
                    data-test='benefits-block-benefits'/>
                {isMinTablet &&
                    <ST.SBaseButton
                        type={btnTypes.ACCENT}
                        text='Подключить'
                        data-test='benefits-block-connect-btn'
                        onClick={connectBtnHandler}
                    />}
            </WideContainer>
        </ST.Wrapper>
    );
};

export default BannerBlock;
